export default __webpack_public_path__ + "6b579e7113385d52346c702e548e8c4c.svg";